import { render, staticRenderFns } from "./PlacePage.vue?vue&type=template&id=2ba64774&scoped=true&"
import script from "./PlacePage.vue?vue&type=script&lang=js&"
export * from "./PlacePage.vue?vue&type=script&lang=js&"
import style0 from "./PlacePage.vue?vue&type=style&index=0&id=2ba64774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba64774",
  null
  
)

export default component.exports